import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Alert } from '@uhg-abyss/web/ui/Alert';

const BoxHeaderText = styled('h4', {
  position: 'relative',
  marginBottom: '20px',
  fontWeight: 400,
  fontSize: '24px',
  width: '100%',
  color: '$primary1',
});
const HelpText = styled('p', {
  fontWeight: 'normal',
  fontSize: '14px',
  marginBottom: 'auto',
  paddingBottom: '20px',
});

const SecurityContainer = styled('div', {
  border: '1px solid rgb(219, 219, 219)',
  background: '$white',
  padding: '25px',
  marginBottom: '20px',
  zIndex: 1,
});

const AlertDisplay = styled('div', {
  marginBottom: '2%',
});

export const MedicaidId = ({
  handleChooseAnotherMethod,
  showMedicaidError,
}) => {
  const MedicaidValidationErrorBar = () => {
    const descriptionArray = showMedicaidError.split('|');
    return (
      <React.Fragment>
        <AlertDisplay>
          <Alert variant="error" title={descriptionArray[0]}>
            {descriptionArray[1]}
          </Alert>
        </AlertDisplay>
      </React.Fragment>
    );
  };
  return (
    <React.Fragment>
      {showMedicaidError && <MedicaidValidationErrorBar />}
      <SecurityContainer>
        <BoxHeaderText>Medicaid Provider ID Validation</BoxHeaderText>
        <HelpText>
          Please enter your state-issued Medicaid Provider ID for validation.
        </HelpText>
        <Flex direction="row">
          <TextInput
            css={{
              'abyss-text-input-root': { width: '50%', paddingRight: '10px' },
            }}
            id="medicaidIdInput"
            model="PAASelfAttestation.medicaidIdInput"
            label="Medicaid ID"
            aria-label="Medicaid ID"
            validators={{
              required: 'Medicaid Id is required',
            }}
            isClearable
            maxLength={50}
          />
          <TextInput
            css={{
              'abyss-text-input-root': {
                width: '50%',
                marginTop: '0 !important',
              },
            }}
            id="zipCodeInput"
            model="PAASelfAttestation.zipCodeInput"
            label="Zip Code"
            aria-label="Zip Code"
            validators={{
              required: 'Zip Code is required',
            }}
            isClearable
            maxLength={5}
          />
        </Flex>
      </SecurityContainer>
      <Flex justify="space-between">
        <Button
          variant="outline"
          before={<IconSymbol icon="arrow_back" color="$primary1" />}
          onClick={handleChooseAnotherMethod}
        >
          Choose another method
        </Button>
        <Button
          type="submit"
          after={<IconSymbol icon="arrow_forward" color="$primary2" />}
        >
          Next
        </Button>
      </Flex>
    </React.Fragment>
  );
};

MedicaidId.propTypes = {
  handleChooseAnotherMethod: PropTypes.func.isRequired,
  showMedicaidError: PropTypes.string.isRequired,
};
